<script>
    export let paste

    import HumanFileSize from './HumanFileSize.svelte'
    import HumanTimestamp from './HumanTimestamp.svelte'

    const get_href = paste_id => {
        if (paste_id) {
            paste_id = paste_id.replace('paste_', '')
            return `/view/${paste_id}`
        }
        return '/'
    }
</script>

<style>
    .paste_info {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
    }
    .paste_info__spacer {
        flex-grow: 1;
    }

    .paste_listing {
        cursor: pointer;
        display: block;
    }
</style>

<a class="box paste_listing" href={get_href(paste.paste_id)}>
    <div class="level">
        <div class="level-left">
            <span class="icon is-large">
                <i class="fas fa-2x fa-file-code"></i>
            </span>
            
            <div>
                <strong>{paste.title}</strong><br/>
                {#if paste.description}
                    {paste.description}
                {:else}
                    <i>No description.</i>
                {/if}
            </div>
        </div>
        <div class="level-right">
            <span class="icon">
                <i class="fas fa-arrow-right"></i>
            </span>
        </div>
    </div>

    <div class="paste_info">
        <div class="paste_info__item">
            <HumanTimestamp stamp={paste.created}/>
        </div>

        <div class="paste_info__spacer"></div>
        
        <div class="paste_info__item">
            <HumanFileSize bytes={paste.size}/>
        </div>
        
    </div>
    
</a>


